import React, { useState } from 'react';
const faqs = [{
  question: '¿Qué es exactamente este producto?',
  answer: 'Es un recurso digital con actividades diseñadas para estimular el desarrollo cognitivo y emocional de niños entre 1 y 3 años.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Después de la compra, recibirás un enlace para descargar todo el contenido directamente en tu dispositivo.'
}, {
  question: '¿Necesito internet para usarlo?',
  answer: 'Solo necesitas internet para descargarlo. Luego podrás acceder a todo el material sin conexión.'
}, {
  question: '¿Está dividido por edades o niveles?',
  answer: 'Sí, está estructurado por tramos de edad para adaptarse mejor al ritmo de desarrollo de tu peque.'
}, {
  question: '¿Puedo imprimirlo todo de una vez?',
  answer: 'Sí, puedes imprimirlo completo o seleccionar solo las páginas que necesites.'
}, {
  question: '¿Es útil para colegios o jardines?',
  answer: 'Sí, muchas instituciones lo usan como material complementario para sus clases.'
}, {
  question: '¿Este material reemplaza al colegio?',
  answer: 'No lo reemplaza, pero lo complementa de forma eficaz en casa con actividades de calidad.'
}, {
  question: '¿Sirve para más de un niño?',
  answer: '¡Claro! Puedes usarlo con todos los niños de la familia cuantas veces quieras.'
}, {
  question: '¿Hay devolución si no me gusta?',
  answer: 'Sí, tienes una garantía de satisfacción de 30 días desde tu compra.'
}, {
  question: '¿Qué resultados puedo esperar al usar este material?',
  answer: 'Verás mejoras en la atención, lenguaje y vínculo emocional con tu peque si lo usas de forma constante.'
}, {
  question: '¿Cuánto tiempo al día debo dedicarle?',
  answer: 'Con solo 15-20 minutos diarios puedes lograr grandes avances sin agobios.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-6 px-4 max-w-xl mx-auto" data-id="element-61">
      <div className="grid grid-cols-2 gap-2 mb-6" data-id="element-62">
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1770713951/IMG_2050-1_perhn1.gif" alt="GIF actividades interactivas PDF" className="rounded-xl shadow-md" data-id="element-63" />
        <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1770713951/IMG_2045-1_1_f02tlf.gif" alt="GIF libro usado por mamás" className="rounded-xl shadow-md" data-id="element-64" />
      </div>

      <h2 className="text-center text-xl font-bold text-blue-800 mb-4" data-id="element-65">
        ❓ PREGUNTAS FRECUENTES
      </h2>

      <div className="space-y-2" data-id="element-66">
        {faqs.map((faq, index) => <div key={index} className="border border-gray-300 rounded-lg overflow-hidden shadow-sm" data-id="element-67">
            <button onClick={() => toggle(index)} className="w-full text-left px-4 py-3 font-semibold text-base text-gray-800 bg-white hover:bg-gray-50 flex justify-between items-center" data-id="element-68">
              <span data-id="element-69">{faq.question}</span>
              <span className="ml-2 text-gray-500 text-sm" data-id="element-70">
                {openIndex === index ? '▲' : '▼'}
              </span>
            </button>
            {openIndex === index && <div className="px-4 py-2 text-sm text-gray-700 bg-gray-50" data-id="element-71">
                {faq.answer}
              </div>}
          </div>)}
      </div>
    </section>;
}